import API from '../dataApi';

// -- Events --------------------------------------------------------------------
export const getEvents = (derasarId) => API.get('/events', { params: { derasarId } });
export const createEvent = (data) => API.post('/events', data);
export const updateEvent = (id, data) => API.put(`/events/${id}`, data);
export const deleteEvent = (id) => API.delete(`/events/${id}`);
export const getEventOfferSummary = (id) => API.get(`/events/${id}/pledge-summary`);
export const getEventContributions = (id, derasarId) => API.get(`/events/${id}/contributions`, { params: { derasarId } });
